export default __webpack_public_path__ + "c315ced8fdf580f84189014737f93146.png";